import { useEffect } from "react";
import { getTheme, normalizeStoreFont, storeFontCSS, loadStoreFonts } from "../config/theme.js";

export function ThemeWrapper({ template, children, bgColor, storeFont }) {
  const theme = getTheme(template);
  const font = normalizeStoreFont(storeFont);
  const cls = `theme-${template || "default"}${font !== "classic" ? ` sf-font-${font}` : ""}`;
  if (font !== "classic") loadStoreFonts();
  // Optional per-store background override (storeUser.bg_color). Falls back to the
  // template's default when not set, so every other store is unchanged.
  const bg = bgColor || theme.bodyBg;

  useEffect(() => {
    document.body.style.background = bg;
    document.body.style.color = theme.T.dark ? "#fff" : "";
    return () => {
      document.body.style.background = "";
      document.body.style.color = "";
    };
  }, [template, bg]);

  return (
    <div className={cls} style={{ minHeight: "100vh", background: bg, color: theme.T.dark ? "#fff" : "inherit" }}>
      {theme.scopedCSS && <style>{theme.scopedCSS}</style>}
      {font !== "classic" && <style>{storeFontCSS(font)}</style>}
      {children}
    </div>
  );
}
